import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Dialog } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';

export type DialogType = 'warning' | 'success' | 'error' | 'info';

@Component({
  selector: 'app-dialog',
  imports: [
    CommonModule,
    Dialog,
    ButtonModule
  ],
  templateUrl: './dialog.html',
  styleUrl: './dialog.scss'
})
export class AppDialog {
  @Input() visible: boolean = false;
  @Input() type: DialogType = 'info';
  @Input() title: string = '';
  @Input() message: string | string[] = '';
  @Input() buttonText: string = '';
  @Input() modal: boolean = true;
  @Input() closable: boolean = false;

  @Output() visibleChange = new EventEmitter<boolean>();
  @Output() onButtonClick = new EventEmitter<void>();

  onCloseDialog() {
    this.visible = false;
    this.visibleChange.emit(this.visible);
  }

  onConfirm() {
    this.onButtonClick.emit();
  }

  get iconClass(): string {
    const icons = {
      warning: 'pi pi-exclamation-triangle',
      success: 'pi pi-check-circle',
      error: 'pi pi-times-circle',
      info: 'pi pi-info-circle'
    };
    return icons[this.type];
  }

  get containerClass(): string {
    return `dialog-container ${this.type}`;
  }

  getIconStyle(): { color: string } {
    const colors = {
      success: '#ffffff',
      warning: '#62581a',
      error: '#ffffff',
      info: '#001117'
    };
    return { color: colors[this.type] };
  }

  get messageLines(): string[] {
    return Array.isArray(this.message) ? this.message : [this.message];
  }
}